// Verifica si un valor es un objeto plano
function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

// Convierte una cadena a snake_case
function toSnakeCase(str: string): string {
  return str
    .replace(/([A-Z])/g, '_$1')
    .replace(/[-\s]+/g, '_')
    .toLowerCase();
}

// Convierte recursivamente todas las claves de un objeto a snake_case
export function keysToSnakeCase<T>(input: T): T {
  if (Array.isArray(input)) {
    return input.map(keysToSnakeCase) as unknown as T;
  }
  if (isPlainObject(input)) {
    const result: Record<string, unknown> = {};
    Object.keys(input).forEach((key) => {
      const snakeKey = toSnakeCase(key);
      result[snakeKey] = keysToSnakeCase((input as Record<string, unknown>)[key]);
    });
    return result as T;
  }
  return input;
}
